import { render, staticRenderFns } from "./bh-flow-arrow.vue?vue&type=template&id=19008162&scoped=true&lang=pug"
var script = {}
import style0 from "./bh-flow-arrow.vue?vue&type=style&index=0&id=19008162&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19008162",
  null
  
)

export default component.exports